<template>
    <div class="p-t-xs-20 p-b-xs-20">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg-6">
                    <div class="m-b-xs-20">
                        <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                            <div class="ak-panel__header ak-panel__header--small">
                                <div class="ak-panel__title">
                                    {{ $t('Lid') }}
                                </div>
                            </div>
                            <div class="ak-panel__body ak-panel__body--small reading">
                                <strong>{{ request.user.card.name }}</strong> ({{ request.user.card.organisation }}) <br />
                                <span class="fa fa-envelope"></span> <a :href="`mailto:${request.user.card.email}`">{{ request.user.card.email }}</a> <br />
                                <span class="fa fa-home"></span> {{ request.user.card.address }}<br />
                                <template v-for="phone in request.user.card.phones">
                                    <span v-if="phone.type === 'mobile'" class="fa fa-mobile-phone"></span>
                                    <span v-else class="fa fa-phone"></span>
                                    {{ phone.phone }} <br />
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-6">
                    <div class="m-b-xs-20">
                        <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                            <div class="ak-panel__header ak-panel__header--warning ak-panel__header--small">
                                <div class="ak-panel__title">
                                    {{ $t('Vorige attesten') }}
                                </div>
                            </div>
                            <div class="ak-panel__body ak-panel__body--small reading">
                                <table v-if="requests.length" class="ak-table ak-panel__table">
                                    <thead>
                                        <tr class="ak-table-row">
                                            <th class="ak-table-head">
                                                 {{ $t('Datum') }}
                                            </th>
                                            <th class="ak-table-head">
                                                 {{ $t('Merk') }}
                                            </th>
                                            <th class="ak-table-head">
                                                 {{ $t('Dealer') }}
                                            </th>
                                            <th class="ak-table-head">
                                                 {{ $t('Goedgekeurd') }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="userRequest in requests" :key="userRequest.hashId" class="ak-table-row">
                                            <td class="ak-table-column">
                                                {{ userRequest.dateCreatedForDisplay }}
                                            </td>
                                            <td class="ak-table-column">
                                                {{ userRequest.brandName }}
                                            </td>
                                            <td class="ak-table-column">
                                                {{ userRequest.certificateName }}
                                            </td>
                                            <td class="ak-table-column">
                                                {{ userRequest.isApproved }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-12">
                <div class="ak-panel ak-panel--no-padding m-b-xs-20">
                    <ak-form
                        :bundle="bundle"
                        :definition="definition"
                        :objectId="objectId"
                        :relationString="relationString"
                        @save="backToGrid"
                        @cancel="attemptClose(close)"
                        v-on="$listeners"
                    />
                </div>
            </div>
        </div>
        <ak-loader size="large" :loading="loading" />
    </div>
</template>

<script>
export default {
    name: 'CarRequestForm',
    data() {
        return {
            request: null,
            requests: null,
            loading: false,
        }
    },
    computed: {
        bundle() {
            return 'car-request';
        },
        definition() {
            return 'form';
        },
        objectId() {
            return this.$route.params.hashId;
        },
        relationString() {
            return this.$route.params.relationString;
        }
    },
    methods: {
        async initialize() {
            this.loading = true;
            const result = await this.$get('/car-request-certificate/' + this.$route.params.hashId);
            if (result.success) {
                this.request = result.data.request;
                this.requests = result.data.requests;
            }

            this.loading = false;
        },
        backToGrid() {
            this.$router.push({name: 'grid', params:{bundle: 'car-request', gridDefinition: 'grid'}});
        },
        close() {
            this.$router.back();
        },
        attemptClose(close) {
            if (! this.alertUnsaved) {
                close();
                return;
            }

            this.showConfirm = true;
            this.confirmCallback = close;
        }
    },
    created() {
        this.initialize();
    }
}
</script>
